import React from 'react';
import { CHECKOUT_URL, PRICING_ANCHOR } from './constants';
interface CTAButtonProps {
  children: React.ReactNode;
  /** When true the button goes straight to checkout, otherwise it scrolls to the pricing section. */
  checkout?: boolean;
  className?: string;
}
export function CTAButton({
  children,
  checkout = false,
  className = ''
}: CTAButtonProps) {
  const base = 'block w-full text-center cursor-pointer px-3 py-3 sm:py-3.5 font-heading font-bold text-[13px] sm:text-lg uppercase tracking-wide rounded-lg bg-navy text-white hover:bg-navy-dark hover:scale-[1.02] transition-all duration-200 border-b-4 border-gold active:border-b-0 active:translate-y-1 shadow-[0_4px_14px_0_rgba(24,58,99,0.35)]';
  if (checkout) {
    return <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className={`${base} ${className}`} data-id="element-31" data-mp="2yqusydl5qc1n">
        {children}
      </a>;
  }
  return <a href={PRICING_ANCHOR} className={`${base} ${className}`} data-id="element-32" data-mp="38q3mj5c41onh">
      {children}
    </a>;
}